<app-material>
    <div class="header" header>
        <h2>{{ 'admin.plants.table.title' | translate }}</h2>
        <app-button *ngIf="shouldRenderModifiers()"
                    (clicked)="openPlantModal()">{{ 'admin.plants.buttons.addPlant' | translate }}
        </app-button>
    </div>
    <ng-container body>
        <app-plants-table [plants]="plants"
                          [isLoading]="isLoadingPlants"
                          [tableConfig]="tableConfig"
                          [headerBackgroundColor]="'rgba(162, 186, 210, .3)'"
                          (sortChange)="onSortChange($event)"
                          (filterChange)="onFilter($event)"
                          (rowClick)="onTableRowClick($event)"
                          (duplicateRow)="onDuplicateRow($event)"
                          (pageChange)="onPageChange($event)">
        </app-plants-table>
    </ng-container>
</app-material>
<app-plant-create-modal
    [isLoading]="isLoadingPlants"
    (onCreate)="create($event)"
    (onUpdate)="update($event)"
    (onDelete)="remove($event)"
    [lines]="lines">
</app-plant-create-modal>

<app-documents-location-confirmation-modal
    (confirm)="onConfirm($event)">
</app-documents-location-confirmation-modal>

